/** Suffix of the PDF source object next to a drawing's raster (D4). */
export const BLUEPRINT_SOURCE_SUFFIX = '_source';

/**
 * Storage path of a drawing's PDF source. Always derived from the raster's `storagePath`, never
 * from the DB path: the iOS-drawn plan keeps its object at `buildings/{b}/blueprints/{key}` while
 * its node sits under the level.
 */
export function blueprintSourceStoragePath(rasterStoragePath: string): string {
    return `${rasterStoragePath}${BLUEPRINT_SOURCE_SUFFIX}`;
}
